import { apiClient } from './client';
import type { DashboardData, SystemHealth, TimeSeriesResponse, EntityMetricsResponse } from '@/types/dashboard';

export async function getDashboardData(): Promise<DashboardData> {
  return apiClient.get('/api/dashboard');
}

export async function getDashboardHealth(): Promise<SystemHealth> {
  return apiClient.get('/api/dashboard/health');
}

export async function getDashboardTimeSeries(range: '24h' | '7d' | '30d' = '24h'): Promise<TimeSeriesResponse> {
  return apiClient.get(`/api/dashboard/timeseries?range=${range}`);
}

export async function getDashboardEntityMetrics(): Promise<EntityMetricsResponse> {
  return apiClient.get('/api/dashboard/entity-metrics');
}

export async function resetCircuitBreaker(targetSystem: string): Promise<{ message: string; targetSystem: string; state: string; resetAt: string }> {
  return apiClient.post('/api/dashboard/circuit-breaker/reset', { targetSystem });
}
